import { type NetworkType } from '@capsicum/common';
import { type CardProps, NetworkIcon, SkeletonItem } from '@capsicum/common-web';

import {
	IconWrapper,
	MediaWrapper,
	NftCardMediaSkeleton,
	NftCardWrapper,
	NftCardWrapperContent,
	NftCardWrapperTitle,
	NftWrapper,
	SkeletonWrapper,
	TextWithEllipsis
} from './NftCard.styles';

export type NftCardProps = CardProps & {
	backgroundImageUrl: string;
	interactive?: boolean;
	network?: NetworkType;
	nftImageUrl: string;
	onActivate?: () => void;
	size?: 'default' | 'small';
	subtitle?: string;
	title: string;
};

// NftCard skeleton
export const NftCardSkeleton = () => (
	<SkeletonWrapper>
		<NftCardMediaSkeleton />
		<NftCardWrapper.Content>
			<NftCardWrapper.Title>
				<SkeletonItem height="12px" width="50%" />
			</NftCardWrapper.Title>
			<NftCardWrapper.SubTitle>
				<SkeletonItem height="12px" width="100%" />
			</NftCardWrapper.SubTitle>
		</NftCardWrapper.Content>
	</SkeletonWrapper>
);

export const NftCard = ({
	backgroundImageUrl,
	interactive = true,
	network,
	nftImageUrl,
	onActivate,
	size = 'default',
	subtitle,
	title,
	...props
}: NftCardProps) => {
	const handleClick = () => {
		if (!interactive) return;

		onActivate?.();
	};

	return (
		<NftCardWrapper
			{...props}
			$interactive={interactive}
			$size={size}
			testID={props.testID}
			onActivate={handleClick}
		>
			<MediaWrapper $backgroundImage={backgroundImageUrl} $size={size} testID={`${props.testID}-backgroundImage`}>
				{network && (
					<IconWrapper $size={size}>
						<NetworkIcon
							color="white"
							network={network}
							size={size}
							testID={`${props.testID}-networkIcon`}
						/>
					</IconWrapper>
				)}
				<NftWrapper $backgroundImage={nftImageUrl} $size={size} />
			</MediaWrapper>
			<NftCardWrapperContent $size={size}>
				<NftCardWrapperTitle $size={size}>
					<TextWithEllipsis variant={size === 'small' ? 'text4' : 'title1'}>{title}</TextWithEllipsis>
				</NftCardWrapperTitle>
				{subtitle && (
					<NftCardWrapper.SubTitle>
						<TextWithEllipsis variant={size === 'small' ? 'text4' : 'title1'}>{subtitle}</TextWithEllipsis>
					</NftCardWrapper.SubTitle>
				)}
			</NftCardWrapperContent>
		</NftCardWrapper>
	);
};
